import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { switchMap,mergeMap,tap,catchError } from 'rxjs/operators';
import { SharedService } from '../shared/shared.service';
import { ProjectService } from '../../project/project.service';
import { ResultComponent } from 'src/app/project/result/result.component';
import { faBookReader } from '@fortawesome/free-solid-svg-icons';

@Injectable({
  providedIn: 'root'
})

export class CalculateService {
  //Modified by PP(2022-11-16) : Load project unable to go results page due to ASTM/CLD in project.component.html unitID = this.projectService.projectdetails.projectInfo.unitId ;
  unitID = 0; //Modified by PP(2022-11-16) : Load project unable to go results page due to ASTM/CLD in project.component.html

  constructor(
    private sharedService: SharedService,
    private projectService: ProjectService
  ) {}

  ngOnInit(): void {
    //Modified by PP(2022-11-16) : Load project unable to go results page due to ASTM/CLD in project.component.html - START
    if (this.projectService.projectdetails != undefined || this.projectService.projectdetails != null) {
      this.unitID = this.projectService.projectdetails.projectInfo.unitId;
    }
    //Modified by PP(2022-11-16) : Load project unable to go results page due to ASTM/CLD in project.component.html - END
  }

  ConvertTemperature(num, convertToUnit) {
    var newValue = 0;
    try {
      if (num === null) {
        return num = 0;
      }

      switch (convertToUnit) {
        case "SI":
          newValue = (5 / 9 * (num) )- 32;//ConvertTemp2Celcius
          break;

        case "US":
          newValue = (9 / 5* num )+ 32; //ConvertTemp2Fahrenheit
          break;

        case "CelciusToKelvin":
          newValue = 273.15 + num; //296.15
          break;

        case "KelvinToCelcius":
          break;
      }

    } catch(e) {
      console.log(e);
      throwError(e.message);
    }
    return newValue;
  }

  ConvertVapourPa(vaVal, convertToUnit) {
    try {
      if (vaVal === null) {
        return vaVal = 0;
      }

      switch (convertToUnit) {
        case "SI":
          vaVal = vaVal * 3.3863799999995954;
          break;

        case "US":
          vaVal = vaVal / 3.3863799999995954;
          break;
      }

    } catch(e) {
      console.log(e);
      throwError(e.message);
    }

    return vaVal;
  }

  ConvertConcentration(Concentratevalue, vMw, vVm, convertToUnit) {
    try {

      if (Concentratevalue === null) {
        return Concentratevalue = 0;
      }

      var newValue = 0;
      switch (convertToUnit) {
        case "ppb":
          newValue = ((Concentratevalue * vMw) / vVm) / 1000;
          break;

        case "mgm3":
          newValue = ((Concentratevalue * 1000) / vMw) * vVm;
          break;
      }
    } catch(e) {
      console.log(e);
      throwError(e.message);
    }

    return newValue;
  }

  CalculateConcentration(pConc, pInputValueType, pUnitID, pNumberFormat, pTemperature, pMolWeight) {
    var CalculatedConcValue = 0;
    try {
      if (pConc === null) {
        return pConc = 0;
      }

      var vPreviousConcUnit = "";
      var TemperatureValue = 0; //vTc

      switch(pUnitID) {
        case 1:
          TemperatureValue = this.sharedService.convertLocaletoNumber(pTemperature, pNumberFormat);
          break;

        case 2:
          TemperatureValue = this.ConvertTemperature(this.sharedService.convertLocaletoNumber(pTemperature, pNumberFormat), "SI");
          break;
      }

      var TemptoKelvin = undefined;
      TemptoKelvin = this.ConvertTemperature(this.sharedService.convertLocaletoNumber(TemperatureValue, pNumberFormat), "CelciusToKelvin");

      var MolecularVolume = undefined;
      MolecularVolume = this.CalculateMolecularVolume(TemptoKelvin);
      if (isNaN(MolecularVolume) == true) {
        MolecularVolume = 0;
      }

      if (pInputValueType == "") {
        pInputValueType = "ppb";
      }

      var returnConcValue = undefined;
      switch (pInputValueType) {
        case "ppb": //CLD2.0 selected concentration unit is mg/m³ but passed in parameter for calculation is ppb
          //returnConcValue = this.ConvertConcentration(this.sharedService.convertLocaletoNumber(pConc, pNumberFormat), this.sharedService.convertLocaletoNumber(pMolWeight, pNumberFormat), MolecularVolume, "ppb");
          //CalculatedConcValue = parseFloat(returnConcValue.toFixed(3));

          returnConcValue = this.ConvertConcentration(this.sharedService.convertLocaletoNumber(pConc, pNumberFormat), this.sharedService.convertLocaletoNumber(pMolWeight, pNumberFormat), MolecularVolume, "mgm3");
          CalculatedConcValue = parseFloat(returnConcValue.toFixed(3));
          break;

        case "mg/m³": //CLD2.0 selected concentration unit is ppb but passed in parameter for calculation is mg/m³
          //returnConcValue = this.ConvertConcentration(this.sharedService.convertLocaletoNumber(pConc, pNumberFormat), this.sharedService.convertLocaletoNumber(pMolWeight, pNumberFormat), MolecularVolume, "mgm3");
          //CalculatedConcValue = parseFloat(returnConcValue.toFixed(3));

          returnConcValue = this.ConvertConcentration(this.sharedService.convertLocaletoNumber(pConc, pNumberFormat), this.sharedService.convertLocaletoNumber(pMolWeight, pNumberFormat), MolecularVolume, "ppb");
          CalculatedConcValue = parseFloat(returnConcValue.toFixed(3));
          break;
      }

    } catch(e) {
      console.log(e);
      throwError(e.message);
    }

    return CalculatedConcValue;
  }

  CalculateMolecularVolume(tempVal) {
    try {
      if (tempVal === null) {
        return tempVal = 0;
      }

      var newValue = 0;
      newValue = (0.082054 * tempVal) / 1;
    } catch(e) {
      console.log(e);
      throwError(e.message);
    }

    return newValue;
  }

  ConvertAirFlow(airFlowValue, previousUnit, convertToUnit) {
    try {
      if (airFlowValue === null) {
        return airFlowValue = 0;
      }

      var newValue = 0;

      // Convert back to m3h first
      switch (previousUnit) {
        case "m³/h":
          airFlowValue = airFlowValue;
          break;
        case "CFM":
          airFlowValue = (airFlowValue * 1.7);
          break;
        case "m³/s":
          airFlowValue = (airFlowValue * 3600);
          break;
        case "L/s":
          airFlowValue = airFlowValue * 3.6;
            break;
      }

      // Convert to Desired Unit
      switch (convertToUnit) {
        case "m³/h":
          newValue = Math.round(parseFloat(airFlowValue));
          break;
        case "CFM":
          newValue = airFlowValue / 1.7;
          newValue = Math.round(newValue);
          break;
        case "m³/s":
          newValue = airFlowValue / 3600;
          newValue = parseFloat(newValue.toFixed(3));
          break;
        case "L/s":
          newValue = airFlowValue / 3.6;
          newValue = Math.round(newValue);
          break;
      }
    } catch(e) {
      console.log(e);
      throwError(e.message);
    }

    return newValue;
  }

  CalculateRunningTime(hours,days,weeks) {
    var result = 0;
    if (hours > 0 && days > 0 && weeks > 0) {
      result = hours * days * weeks;
    }
    return result;
  }

  CalculateTotalAirVolume(hours, airflow) {
    var result =0;
    if (hours > 0 && airflow > 0) {
      result = hours * airflow;
    }
    return result;
  }

  ConvertTotalAirVol_US(airVolumem3h) {
    var result = airVolumem3h * 35.3146667;
    return result;
  }

  ConvertMediaSize(val, convertToUnit) {
    try {
      if (val === null) {
        return val = 0;
      }

      switch (convertToUnit) {
        case "SI":
          val = (val * 25.4);
          //val = Math.round(parseFloat(val));
          val = Math.round(val);
          break;
        
        case "US":
          val = (val / 25.4);
          val = val.toFixed(2);
          break;
      }

    } catch(e) {
      console.log(e);
      throwError(e.message);
    }

    //return val;
    return parseFloat(val); //Make it numeric and not number
  }

  ConvertKgToPounds(val, convertToUnit) {
    try {
      if (val === null) {
        return val = 0;
      }

      switch (convertToUnit) {
        case "SI":
          val = (val * 0.453592);
          val = val.toFixed(1);
          break;
        
        case "US":
          val = (val / 0.453592);
          val = val.toFixed(1);
          break;
      }

  } catch(e) {
    console.log(e);
    throwError(e.message);
  }

  return parseFloat(val);
  }

  ConvertFrontVelocity(val, convertToUnit) {
    try {
      if (val === null) {
        return val = 0;
      }

      switch (convertToUnit) {
        case "SI":
          val = val * 0.00508333333333333;
          val = val.toFixed(2);
          break;
        
        case "US":
          val = val / 0.00508333333333333;
          val = val.toFixed(2);
          break;
      }

  } catch(e) {
    console.log(e);
    throwError(e.message);
  }

  return parseFloat(val);
  }

}